// extracted by mini-css-extract-plugin
export default {"mainContainer":"PeriodicReport_mainContainer__R8Beb"};